import { createUseStyles } from 'react-jss'

import customColors from 'src/config/colorsV2'
import { INFO_STYLES } from '@components/Input/styles'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles(
  (theme: Theme) => ({
    root: {
      '& > div:not(:first-child)': {
        marginTop: 16,
        [forPhoneOnly]: {
          marginTop: 16,
        },
      },
    },
    phoneNumberInputRoot: {
      '& .PhoneInputCountry': {
        paddingLeft: 20,
        paddingRight: 5,
        borderBottom: `1px solid ${customColors.border}`,
        marginRight: 0,
        zIndex: 10,
        background: customColors.white,
      },
      '& .PhoneInputCountryIcon': { width: 24, height: 16 },
      '& .PhoneInputCountryIconImg': {
        display: 'block',
        width: '100%',
        height: '100%',
      },
      '& > div:first-child': {
        backgroundColor: customColors.backgroudSecondary,
        border: 'none',
      },
      '& > div > div:nth-child(2)': {
        width: '100%',
        marginLeft: -4,
        zIndex: 1,
      },
    },

    phoneNumberInputFocus: {
      '& .PhoneInputCountry': {
        borderColor: theme.palette.primary.main,
      },
    },
    phoneNumberInfo: INFO_STYLES,
  }),
  { name: 'ContactPerson' }
)
